import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "field flex flex-column gap-2 align-items-start" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Email", -1)
const _hoisted_3 = {
  id: "fullName-help",
  class: "p-error"
}
const _hoisted_4 = { class: "field flex flex-column gap-2 align-items-start" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "password" }, "Password", -1)
const _hoisted_6 = {
  id: "fullName-help",
  class: "p-error"
}

import { useUserStore } from '../stores/UserStore';
import { useApiStatusStore } from '@/stores/ApiStatusStore';
import { useForm, configure } from 'vee-validate';
import * as yup from 'yup';
import InputText from 'primevue/inputtext';
import Button from 'primevue/button';


export default /*#__PURE__*/_defineComponent({
  __name: 'UserLogin',
  setup(__props) {

const userStore = useUserStore();
const apiStatusStore = useApiStatusStore();

const schema = yup.object().shape({
  email: yup.string().required().email().label('Email Address'),
  password: yup.string().required().min(8)
    .matches(/(?=.*[0-9])/, 'Password must contain at least one number')
    .matches(/(?=.*[@#$%^&+=.,!?])/, 'Password must contain at least one special character').label('Password'),
});

const { defineField, handleSubmit, errors } = useForm({
  validationSchema: schema,
});

const [email] = defineField('email');
const [password] = defineField('password');

configure({
  validateOnBlur: true,
  validateOnChange: false,
  validateOnInput: false,
  validateOnModelUpdate: false
})

const onSubmit = handleSubmit((values: any) => {
  userStore.loginUser(values);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args)), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_unref(InputText), {
        modelValue: _unref(email),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(email) ? (email).value = $event : null)),
        id: "email",
        type: "email"
      }, null, 8, ["modelValue"]),
      _createElementVNode("small", _hoisted_3, _toDisplayString(_unref(errors).email), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createVNode(_unref(InputText), {
        modelValue: _unref(password),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(password) ? (password).value = $event : null)),
        id: "password",
        type: "password"
      }, null, 8, ["modelValue"]),
      _createElementVNode("small", _hoisted_6, _toDisplayString(_unref(errors).password), 1)
    ]),
    _createVNode(_unref(Button), {
      type: "submit",
      label: "Login",
      disabled: _unref(apiStatusStore).requestPending('login')
    }, null, 8, ["disabled"])
  ], 32))
}
}

})